$ = require 'jquery'
_ = require 'underscore'
f = require 'effing'

languageParts = (specifier) -> specifier.toLowerCase().split('-')

# Returns true if the desired language is a prefix of the actual language.
#
# For example:
#
# - 'en-us' matches 'en'
# - 'en-us' matches 'en-us'
# - 'en-gb' does not match 'en-us'
matches = (actual, desired) ->
  actualParts = languageParts actual
  desiredParts = languageParts desired

  _.all desiredParts, (part, index) ->
    actualParts[index] == part

# Safari reports locales in all lower-case, in contrast
# to every other browser ever.
normalizeLocale = (locale) ->
  # We've seen Chrome report navigator.language as
  # en-SA@CALENDAR=GREGORIAN, which is bananas.
  locale = locale.split('@')[0]

  # We've seen Chrome report navigator.language as
  # en-US.UTF-8, which is also bananas.
  locale = locale.split('.')[0]

  components = locale.split /[-_]/
  if components.length == 1
    components[0]
  else
    [lang, place, rest...] = components
    [lang, place.toUpperCase(), rest...].join('-')

preferred = _.chain [
  $.cookie('lang')              # Accept-Language echo
  navigator.language            # Safari, Chrome
  (navigator.languages ? [])... # Chrome, Firefox
  navigator.userLanguage        # Internet Explorer
  navigator.browserLanguage     # Fallback? Not sure.
  'en-GB'                       # Just in case
]
.compact()
.map (locale) -> normalizeLocale(locale)
.unique()
.value()

module.exports =
  preferred: preferred
  matches: matches
  normalizeLocale: normalizeLocale

  is: (desired) ->
    matches preferred[0], desired

  mostPreferred: (orderedPreferences, langs) ->
    _.chain orderedPreferences
    .map (preferredLang) -> _.find langs, f(matches, preferredLang)
    .compact()
    .first()
    .value()



// WEBPACK FOOTER //
// ./app/scripts/lib/language.coffee